

import React from 'react'
import Button from 'react-bootstrap/Button';
import '../MyProfile/editSuccesfully.css'
import '../MyProfile/myProfile.css'


export default function EiditSuccesfully({ setEditSucess }) {
    return (
        <div id='profile_all_Sucess'>
            <div className='total_header_profile'>
                <div className='heading_name_profile'>
                    My profile
                </div>
                <div>
                    <img onClick={(e) => { setEditSucess(false) }} src='/DCM-img/cross_arrow.png' alt='cross logo'></img>
                </div>
            </div>
            
            <div className='detail_all_profile'>
                <div >
                    <div className='profile__sucess_all'>
                        <div className='d-flex'>
                            <img src='/DCM-img/Profile_photo.png' alt='ProfilePhoto'></img>
                            <div className='Student_name'>
                                Ravi Kumar
                            </div>
                        </div>
                        <div className='sucess-msg-all'>
                            <img class="img-fluid" src='/DCM-img/sucess-msg.png' alt='Sucess msg'></img>
                        </div>
                    </div>

                </div>

                <div className='all_one_n col-8'>
                    <div>
                        <div className='gender_class '>
                            <div >
                                <div className='gender'>
                                    Gender
                                </div>
                                <div className='male_H'>
                                    Male
                                </div>
                            </div>

                        </div>

                        <div className='contact_class '>
                            <div className='gender_class '>
                                <div className='gender'>
                                    School email id
                                </div>
                                <div className='male_H'>
                                    charlie@kend-vidyala-student.com

                                </div>
                            </div>

                        </div>

                        <div className='gender_class '>
                            <div class=''>
                                <div className='gender'>
                                    School id
                                </div>
                                <div className='male_H'>
                                    KV-00231
                                </div>
                            </div>

                        </div>


                        <div className='gender_class '>
                            <div >
                                <div className='gender'>
                                    Class
                                </div>
                                <div className='total_class_N'>
                                    <button className='btn_claasName'>Class 9-B</button>
                                    <button className='btn_claasName'>Class 10-D</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='left_dob'>
                        <div className='gender_class ' >
                            <div className='gender'>
                                DOB
                            </div>
                            <div className='Dob_date'>
                                14-02-2003
                            </div>
                        </div>
                        <div className='gender_class '>
                            <div className='gender'>
                                Contact number
                            </div>
                            <div className='Dob_date'>
                                98121 11921
                            </div>
                        </div>
                        <div className='gender_class '>
                            <div className='gender'>
                                Emergency contact number
                            </div>

                            <div className='Dob_date'>
                                98121 11921
                            </div>

                        </div>
                        <div className='gender_class '>
                            <div className='gender'>
                                Address
                            </div>

                            <div className='Dob_date'>
                                321, South Avenue
                            </div>

                        </div>

                    </div>
                </div>
                <div class="row mt-3">

                    <div className='gender'>
                        Class handling
                    </div>


                    <div class='ml-3 mt-1'>
                        <div className='d-flex'>
                            <span className='handling_sub_h'>As subject teacher</span>
                            <div>
                                <button className='btn_claasN1'>Class 10-E_English</button>
                                <button className='btn_claasN1'>Class 10-E_Social Science</button>
                                <button className='btn_claasN1'>Class 9-E_Hindi</button>
                                <button className='btn_claasN1'>Class 9-E_Marathi</button>
                            </div>
                        </div>
                        <div className='d-flex'>
                            <span className='handling_sub_h2'>As class teacher</span>
                            <div className='mt-1'>
                                <button className='btn_claasN1'>Class 10-E_English</button></div>
                        </div>
                        <div className='d-flex'>
                            <span className='handling_sub_h3'>As coodinator</span>
                            <div className='mt-1'>
                                <button className='btn_claasN1'>Class 10</button>
                                <button className='btn_claasN1'>Class 9</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <Link to='/EditProfile'> */}
                {/* <Button id='Profile_edit_btn' variant="outline-warning">Request for Editing Profile</Button> */}
                {/* </Link> */}

            </div>

        </div >
    )
}
